import React, { useMemo } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { BoxSelection } from 'wix-ui-tpa/cssVars';

import { DispatchType } from '../../types/businessTypes';
import { useGetLayoutSize } from '../LayoutSizeProvider';

import { classes, st } from './FulfillmentPicker.st.css';
import { fulfillmentPickerDataHooks } from './constants';
import { sortByDispatchType } from './dispatchType';

export type FulfillmentPickerOption = {
  type: DispatchType;
  label: string;
  disabled: boolean;
};

export type FulfillmentPickerProps = {
  options: FulfillmentPickerOption[];
  selectedType: DispatchType | undefined;
  isHidden: boolean;
  onSelect: (type: DispatchType) => void;
  className?: string;
};

export const FulfillmentPicker: React.FC<FulfillmentPickerProps> = ({
  options,
  selectedType,
  isHidden,
  onSelect,
  className,
}) => {
  const { t } = useTranslation();
  const { layoutSize } = useGetLayoutSize();

  const sortedOptions = useMemo(() => sortByDispatchType(options), [options]);

  if (isHidden || sortedOptions.length === 0) {
    return null;
  }

  return (
    <BoxSelection
      className={st(classes.root, { [layoutSize]: true }, className)}
      name="fulfillment-picker"
      aria-label={t('header_olo.fulfillmentPicker.ariaLabel')}
      onChange={({ id }) => onSelect(id as DispatchType)}
      data-hook={fulfillmentPickerDataHooks.root()}
    >
      {sortedOptions.map(({ type, label, disabled }) => (
        <BoxSelection.Option
          key={type}
          id={type}
          checked={selectedType === type}
          disabled={disabled}
          data-hook={fulfillmentPickerDataHooks.option({ type })}
        >
          {label}
        </BoxSelection.Option>
      ))}
    </BoxSelection>
  );
};
